import { useQuery } from '@tanstack/react-query';

import { getPacingData } from '../api/ventura/contract';
import { useConfig } from './useConfig';

function useContractPacingData(contractId: number) {
  const { apiHost } = useConfig();

  const query = useQuery({
    queryKey: ['contractPacingData', contractId],
    queryFn: () => getPacingData(apiHost, contractId),
  });

  return query;
}

export default useContractPacingData;
